module.exports = __webpack_public_path__ + "static/media/cent2.424ce9f1.jpg";